import { Fragment } from 'react';
import { pageStore } from '~/pages/strategy_center_admin/pageStore';
export function InstrumentDisplay(props) {
    if (!props.value) {
        return <Fragment />;
    }
    return <Fragment>{pageStore.instrumentsStore.getDisplayName(props.value)}</Fragment>;
}
